module.exports = __webpack_public_path__ + "static/media/impetraLogoWhite.04358f1f.webp";